var _this = this;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from 'react';
import NavigationLink from './NavigationLink.react';
var MainLinks = function MainLinks(_ref) {
  var links = _ref.links,
    hideMenu = _ref.hideMenu,
    location = _ref.location;
  if (!links || links.length <= 0) {
    return null;
  }
  return React.createElement("div", null, links.map(function (item, i) {
    return React.createElement(NavigationLink, _extends({}, item, {
      hideMenu: hideMenu,
      key: i,
      pathname: location && location.pathname
    }));
  }, _this));
};
MainLinks.styleRoot = 'MainLinks';
export default MainLinks;